export const statusMapper: { [key: string]: string } = {
    completed: "Completed",
    upcoming: "Upcoming",
    deleted: "Deleted",
    draft: "Draft",
  };
  